import { render } from "./ToolBarFire.vue?vue&type=template&id=70f6a2a6"
import script from "./ToolBarFire.vue?vue&type=script&lang=js"
export * from "./ToolBarFire.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__